import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { useConditionalScreenLock } from '@/composables/useScreenLock'

export const useDrawerNavigationStore = defineStore('drawerNavigation', () => {
  interface DrawerNavigationContext {
    isShow: boolean,
  }
  const context: DrawerNavigationContext = reactive({
    isShow: false,
  })

  // ドロワーが開いている間はロックを持つ（setup store は effect scope の中で動くため composable を使える）
  useConditionalScreenLock(() => context.isShow, {
    hasBlackOut: true,
    hasBlur: true,
    hasScrollLock: false, // スクロールロックすると、iOS でドロワーナビ内のスクロールができなくなるため、スクロールのロックはしない
  })

  const showDrawerNavigation = ():void => {
    context.isShow = true
  }

  const hideDrawerNavigation = ():void => {
    context.isShow = false
  }

  return {
    // data
    context,

    // methods
    showDrawerNavigation,
    hideDrawerNavigation,
  }
})
